<template>
<div class="chapter">
<div class="inner_page">
<div id="List_of_Maps">
<p class="fm-title1"><b>Maps</b></p>
<p class="img-para">  <span href="#/xhtml/18_Chapter04#ufig_50" title="Link target outside of Sample">1.     Copenhagen</span></p>
<p class="img-para">  <span href="#/xhtml/22_Chapter07#ufig_87" title="Link target outside of Sample">2.     Saragossa</span></p>
<p class="img-para">  <span href="#/xhtml/23_Chapter08#ufig_88" title="Link target outside of Sample">3.     Ciudad Rodrigo</span></p>
<p class="img-para">  <span href="#/xhtml/23_Chapter08#ufig_89" title="Link target outside of Sample">4.     Badajoz</span></p>
<p class="img-para">  <span href="#/xhtml/23_Chapter08#ufig_90" title="Link target outside of Sample">5.     San Sebastian</span></p>
<p class="img-para">  <span href="#/xhtml/24_Chapter09#ufig_91" title="Link target outside of Sample">6.     Danzig</span></p>
<p class="img-para">  <span href="#/xhtml/25_Chapter10#ufig_92" title="Link target outside of Sample">7.     Sackett’s Harbor, Lake Ontario</span></p>
<p class="img-para">  <span href="#/xhtml/25_Chapter10#ufig_93" title="Link target outside of Sample">8.     Niagara Peninsula</span></p>
<p class="img-para">  <span href="#/xhtml/28_Chapter12#ufig_96" title="Link target outside of Sample">9.     Plattsburg, New York</span></p>
<p class="img-para"><span href="#/xhtml/31_Appendix_I#ufig_97" title="Link target outside of Sample">10.     Schweidnitz</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_List_of_Maps.vue?0365acff